/*
 * @Author: lijt
 * @Date: 2023-05-16 09:18:59
 * @LastEditors: lijt
 * @LastEditTime: 2023-06-13 09:55:22
 * @FilePath: /vue_hy_admin/src/utils/pdf.js
 * @Description:
 */
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const downloadPDF = (page, option, fileName, isDownload = false) => {
  const obj = html2canvas(page, option).then(function (canvas) {
    // console.log(page, 'page', option, 'option')
    const obj = canvas2PDF(canvas, fileName, isDownload);
    // console.log(obj, 'obj')
    if (!isDownload) return obj;
  });
  if (!isDownload) return obj;
};

const blobToFile = function (theBlob, fileName) {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
};

const canvas2PDF = (canvas, fileName, isDownload) => {
  console.log(canvas, "canvas");
  const contentWidth = canvas.width;
  const contentHeight = canvas.height;

  // 一页pdf显示html页面生成的canvas高度;
  const pageHeight = (contentWidth / 592.28) * 841.89;
  // 未生成pdf的html页面高度
  let leftHeight = contentHeight;
  // 页面偏移
  let position = 0;

  console.log(leftHeight, "leftHeight", pageHeight, "pageHeight");

  // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
  const imgWidth = 595.28;
  const imgHeight = (595.28 / contentWidth) * contentHeight;

  const pageData = canvas.toDataURL("image/jpeg", 1.0);

  // 第一个参数： l：横向  p：纵向
  // 第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）
  const pdf = new jsPDF("", "pt", "a4");

  // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
  // 当内容未超过pdf一页显示的范围，无需分页
  if (leftHeight < pageHeight) {
    pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
  } else {
    while (leftHeight > 0) {
      pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
      leftHeight -= pageHeight;
      position -= 841.89;
      // 避免添加空白页
      if (leftHeight > 0) {
        pdf.addPage();
      }
    }
  }
  let suffix = "";
  try {
    const flieArr = fileName.split(".");
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = "";
  }
  console.log(suffix, "suffix");
  if (isDownload) {
    // 直接导出文件
    pdf.save(suffix == "pdf" ? fileName : fileName + ".pdf");
  } else {
    const pdfData = pdf.output("blob"); // blob文件流
    const file = blobToFile(
      pdfData,
      suffix == "pdf" ? fileName : fileName + ".pdf"
    );
    // console.log(file, 'file')
    // 返回文件流
    return file;
  }
};
